'use client'

import { useState } from 'react'
import { useTranslations } from 'next-intl'

import { Button } from '../../teqplay-ui'
import ModalPortReporter from '../../Modals/ModalPortReporter'

function SeeAllEventLink() {
  const t = useTranslations('Notifications')
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  return (
    <>
      <Button variant="link" onClick={() => setIsModalOpen(true)}>
        <div>{t('seeAllEventTypes')}</div>
      </Button>
      <ModalPortReporter isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  )
}

export default SeeAllEventLink
